import React from "react";

export class Footer extends React.Component {


    render() { 
        return(
            <footer className="footer text-center ">
                <div className="container">
                    <p className="footer-text">Copyright 2020 Raz Lapid & Amit Solomon. All rights reserved</p>
                </div>
            </footer>
        )
    }
}

export default Footer